import { Component, OnInit, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonHelperService } from 'src/app/services/common-helper.service';
import { ValidationHelperService } from 'src/app/services/validation-helper.service';
import { request } from "http";
declare var $ : any;
@Component({
  selector: "app-are-you-sure-model",
  templateUrl: "./are-you-sure-model.component.html",
  styleUrls: ["./are-you-sure-model.component.scss"],
})
export class AreYouSureModelComponent implements OnInit {
  
  modalForm: FormGroup;
  data;
  errorMessage: any;
  isCrossBtnDisable: boolean = false;
  responseMessage: string;
  constructor(public modal: NgbActiveModal, private fb: FormBuilder, private commonHelper: CommonHelperService,
    private validationService: ValidationHelperService) {}

  ngOnInit() {
    this.modalForm = this.fb.group({
      oldTagName: [''],
      newTagName: [''],
    });
    if(this.data.rdrTagName == 'reName') {
      this.f['oldTagName'].clearValidators();
      this.f['oldTagName'].setValidators([Validators.required]);
      this.f['oldTagName'].updateValueAndValidity();
      this.modalForm.patchValue({ oldTagName: this.data.tagName });
      this.f['newTagName'].clearValidators();
      this.f['newTagName'].setValidators([Validators.required]);
      this.f['newTagName'].updateValueAndValidity();
    }
  }

  get f() {
    return this.modalForm.controls;
  }

  scrollAndShowMessage(className) {
    let el = $('.' + className);
    $('html,body').animate({ scrollTop: (el.offset().top - 150) }, 'slow', () => {
      el.focus();
    });
    setTimeout(() => {
      this.responseMessage = "";
      this.errorMessage = "";
      $('select').blur();
    }, 5000);
  }

  apiCall() {
    let requestForApiCall = {
      token: localStorage.getItem('authToken'),
      domainId: this.data.domainId,
      tagId: this.data.tagId || undefined,
      tagIds: [this.data.tagId],
      orgId: this.data.orgId || undefined,
      tagName: this.data.rdrTagName == 'reName' ? this.f.newTagName.value : this.data.tagName || undefined,
      
    }
    this.isCrossBtnDisable = false;
    this.commonHelper.makeRequest(requestForApiCall, this.data.apiName, true).subscribe(res => {
      if (res.statusCode == 0) {
        this.responseMessage = res.message;
        this.isCrossBtnDisable = true;
        setTimeout(() => {
          this.closeModal(true, false);
        }, 1500);
      } else {
        this.errorMessage = res.message;
      }
      this.commonHelper.animateMessage(this, "containerWrap");
    });
  }

  closeModal(isactionPerformed, isReset = false) {
    if(isReset && this.data.rdrTagName == 'reName') {
      this.ngOnInit();
    } else {
      this.modal.close(isactionPerformed);
    }
  }

}

